export default "__VITE_ASSET__BQVjy6Es__"